import { useEffect } from "react";

import { $generateNodesFromDOM } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { mergeRegister } from "@lexical/utils";
import {
    $createTextNode,
    $getRoot,
    $getSelection,
    $insertNodes,
    $isRangeSelection,
    COMMAND_PRIORITY_NORMAL,
    LexicalCommand,
    createCommand,
} from "lexical";

export const INSERT_TEXT: LexicalCommand<string> = createCommand("INSERT_TEXT");
export const INSERT_HTML: LexicalCommand<string> = createCommand("INSERT_HTML");
export const RESET_HTML: LexicalCommand<string> = createCommand("INSERT_HTML");

export function InsertTextPlugin() {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return mergeRegister(
            editor.registerCommand(
                INSERT_TEXT,
                (text: string) => {
                    editor.update(() => {
                        const selection = $getSelection();
                        if ($isRangeSelection(selection)) {
                            selection.insertNodes([$createTextNode(text)]);
                        } else {
                            $insertNodes([$createTextNode(text)]);
                        }
                    });

                    return true;
                },
                COMMAND_PRIORITY_NORMAL
            ),
            editor.registerCommand(
                INSERT_HTML,
                (html: string) => {
                    try {
                        const parser = new DOMParser();
                        const dom = parser.parseFromString(html, "text/html");
                        const nodes = $generateNodesFromDOM(editor, dom);
                        editor.update(() => {
                            const selection = $getSelection();
                            if ($isRangeSelection(selection)) {
                                selection.insertNodes(nodes);
                            } else {
                                $insertNodes(nodes);
                            }
                        });

                        return true;
                    } catch {
                        return false;
                    }
                },
                COMMAND_PRIORITY_NORMAL
            ),
            editor.registerCommand(
                RESET_HTML,
                (html: string) => {
                    try {
                        const parser = new DOMParser();
                        const dom = parser.parseFromString(html, "text/html");
                        const nodes = $generateNodesFromDOM(editor, dom);
                        editor.update(() => {
                            const root = $getRoot();
                            root.clear();
                            $insertNodes(nodes);
                            root.selectStart();
                        });

                        return true;
                    } catch {
                        return false;
                    }
                },
                COMMAND_PRIORITY_NORMAL
            )
        );
    }, [editor]);

    return null;
}
